import {RootState} from '../rootReducer';

export const modelLinksSelector = (state: RootState) => state.modelLinks;
